/**
 * The blacklist override modal (PREC-2548): what a user is told before a blacklisted lead is
 * contacted, or taken off the blacklist by a status move. Served under `blacklist.override`.
 */
export const enBlacklistOverride = {
	title: {
		contact_one: "Contact a blacklisted lead?",
		contact_other: "Contact {{count}} blacklisted leads?",
		remove_one: "Take a lead off the blacklist?",
		remove_other: "Take {{count}} leads off the blacklist?",
	},
	intro: {
		contact:
			"These leads are on your blacklist. To contact them, they are taken off it: the entries that block them are removed and they move to Found, marked as included by you.",
		remove:
			"The entries that block these leads are removed, so they can be contacted again. Leads who unsubscribed stay on the blacklist.",
	},
	overridableHeading: "Taken off the blacklist",
	refusedHeading: "Stay on the blacklist",
	refusal: {
		unsubscribed: "Unsubscribed — cannot be contacted",
		global: "Blocked by a Signalist-wide entry",
	},
	removeCompany: "Also remove {{companies}} from the blacklist",
	removeCompanyHint:
		"The whole company is on your blacklist, so these leads stay blocked unless the company comes off it too. That unblocks every colleague at the company as well.",
	unknownCompany: "their company",
	competitorNote_one:
		"{{companies}} stays marked as a competitor for everyone else. Only this person is exempted.",
	competitorNote_other:
		"{{companies}} stay marked as competitors for everyone else. Only these {{count}} people are exempted.",
	pageOnlyNote:
		"Your selection spans {{total}} leads. Because blacklisted leads are confirmed one by one, only the leads on this page are sent out.",
	nothingOverridable: "None of these leads can be taken off the blacklist.",
	confirm: {
		contact: "Take off the blacklist and continue",
		remove: "Remove from blacklist",
	},
	skippedToast: "Kept on the blacklist: {{names}}",
	skipReason: {
		unsubscribed: "unsubscribed",
		global: "Signalist-wide entry",
		companyNotRemoved: "company still blacklisted",
	},
	previewFailed: "Could not check these leads against the blacklist.",
	applyFailed: "Could not take these leads off the blacklist.",
};
